import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import { Row, Col } from 'react-bootstrap';
import Breadcrumb from '../../Breadcrumb/Main'
import DeptLeft from '../People/Dept_Left'

const HD = [

    {
        "Name": "Dr. K P Naveen",
        "NameLink": "https://iittp.ac.in/dr-k-p-naveen",
        "Position": "Associate Professor",
        "Category": "Head of the Department",
        "Degree": "Ph.D - Indian Institute of Science, Bangalore, India ",
        "AreasofInterest": "Performance Analysis of Wireless Networks  ",
        "Phone": "0877 2503255",
        "Email": "naveenkp@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/naveenkp.jpg"
    }
]
const Faculty = [


    {
        "Name": "Dr. N N Murty",
        "NameLink": "/dr-n-n-murty",
        "Position": "Professor and Dean (Student Affairs)",
        "Degree": "Ph.D - IIT, Banaras Hindu University, Varanasi, India.",
        "AreasofInterest": "Defect identification and characterization in semiconductors (Diamond, SiC)",
        "Phone": "0877 2503256",
        "Email": "nnmurty@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/nnmurthy.jpg"
    },
    {
        "Name": "Dr. Rama Krishna Sai Gorthi",
        "NameLink": "/dr-rama-krishna-sai-subrahmanyam-gorthi",
        "Position": "Professor and Dean (Academic Affairs)",
        "Degree": "Ph.D - Indian Institute of Technology, Madras, India",
        "AreasofInterest": "Signal/Image Processing, Computer Vision and Pattern Recognition & Machine Learning",
        "Phone": "0877 2503260",
        "Email": "rkg@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/SubramanyamSai.JPG"
    },
    {
        "Name": "Dr. Parthajit Mohapatra",
        "NameLink": "https://iittp.ac.in/dr-parthajit-mohapatra",
        "Position": "Associate Professor",
        "Degree": "Ph.D - Indian Institute of Science, Bangalore, India",
        "AreasofInterest": "Advanced communication techniques for future wireless networks, Physical Layer Secrecy",
        "Phone": "0877 2503257",
        "Email": "parthajit@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/parthajitphoto.jpg"
    },
    {
        "Name": "Dr. Subrahmanyam Gorthi",
        "NameLink": "/dr-subrahmanyam-gorthi",
        "Position": "Associate Professor",
        "Degree": "Ph.D - Swiss Federal Institute of Technology, Switzerland",
        "AreasofInterest": "Medical Image Analysis",
        "Phone": "0877 2503262",
        "Email": "s.gorthi@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/gorti.jpg"
    },

    {
        "Name": "Dr. Abhishek Kumar Jha",
        "NameLink": "https://iittp.ac.in/dr-abhishek-kumar-jha",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Indian Institute of Technology Kanpur, India",
        "AreasofInterest": "RF and Microwaves, Applied Electromagnetics",
        "Phone": "+48 508 686 078",
        "Email": "abhishek.jha@pg.edu.pl",
        "Image": "https://files.iittp.ac.in/images/demo/iit/AKJha.png"
    },
    // {
    //     "Name": "Dr. K P Naveen",
    //     "NameLink": "/dr-k-p-naveen",
    //     "Position": "Head & Associate Professor",
    //     "Degree": "Ph.D - Indian Institute of Science, Bangalore, India",
    //     "AreasofInterest": "Performance Analysis of Wireless Networks",
    //     "Phone": "0877 2503255",
    //     "Email": "naveenkp@iittp.ac.in",
    //     "Image": "https://files.iittp.ac.in/images/demo/iit/naveenkp.jpg"
    // },

    {
        "Name": "Dr. Pooja Vyavahare",
        "NameLink": "https://iittp.ac.in/dr-pooja-vyavahare",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Indian Institute of Technology, Bombay, India",
        "AreasofInterest": "Distributed function computation and optimization, Analysis of communication networks",
        "Phone": "0877 2503258",
        "Email": "poojav@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/PoojaV.png"
    },
    {
        "Name": "Dr. Prashanth Vooka",
        "NameLink": "/dr-prashanth-vooka",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Indian Institute of Technology, Madras, India",
        "AreasofInterest": "Development of Sensor Interfaces, Analog-to-Digital Converters, Measurements, and Instrumentation.",
        "Phone": " ",
        "Email": "prashanthv@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Prashanth.jpg"
    },
    {
        "Name": "Dr. Ramesh Patel",
        "NameLink": "https://iittp.ac.in/dr-ramesh-patel",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Ulsan National Institute of Science and Technology (UNIST), South Korea",
        "AreasofInterest": "Antenna System Architecture for Wireless Communication and Sensing",
        "Phone": "+91 94254 11694",
        "Email": "ramesh.patel@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Dr.Ramesh_Patel_AP.png"
    },
    {
        "Name": "Dr. P. S. SaiKrishna",
        "NameLink": "/dr-sai-krishna",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Indian Institute of Technology, Madras, India",
        "AreasofInterest": "Industrial Automation, Robust & Optimal Control and Cloud Computing QoS Management",
        "Phone": "0877 250 3261",
        "Email": "psskrishna@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/saikrishna1.jpg"
    },
    {
        "Name": "Dr. Sarvendranath Rimalapudi",
        "NameLink": "/dr-sarvendranath-rimalapudi",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Indian Institute of Science, Bangalore, India",
        "AreasofInterest": "Physical layer wireless communication",
        "Email": "sarvendranath@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Dr. Sarvendranath_R.png"
    },
    {
        "Name": "Dr. Srujana Kagita",
        "NameLink": "https://iittp.ac.in/dr-srujana-kagita",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Indian Institute of Technology, Delhi, India",
        "AreasofInterest": "Rf And Microwave Components And Antennas",
        "Email": "srujana.kagita@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/srujana.jpg"
    },

    {
        "Name": "Dr. Swapnil Bhuktare",
        "NameLink": "https://iittp.ac.in/dr-swapnil-bhuktare",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Indian Institute of Technology Bombay, India",
        "AreasofInterest": "Nanoelectronics, Spintronics",
        "Phone": "8976260712",
        "Email": "swapnil@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/swapnil.jpg"
    },
    {
        "Name": "Dr. Vignesh V",
        "NameLink": "/dr-vignesh-v",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Indian Institute of Technology, Kanpur, India",
        "AreasofInterest": "Power System Dynamics, Smart Grids",
        "Phone": "0877 2503263",
        "Email": "vigneshv@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/vignesh.jpg"
    },
    {
        "Name": "Dr. Vijaya Kumar Gurugubelli",
        "NameLink": "https://iittp.ac.in/dr-vijaya-kumar-gurugubelli",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Indian Institute of Technology Madras, India",
        "AreasofInterest": "Device Modeling, Power Semiconductor Devices, Nanoelectronics, Sensors",
        "Email": "vijayg@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Vijaya_Kumar.JPG"
    },
    {
        "Name": "Dr. Viju Nair. R",
        "NameLink": "https://iittp.ac.in/dr-viju-nair-r",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Indian Institute of Science Bangalore, India",
        "AreasofInterest": "Power Electronics",
        "Phone": "917338132816",
        "Email": "vnr@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/vnr.jpg"
    },
    {
        "Name": "Dr. Vikramkumar Pudi",
        "NameLink": "/dr-vikramkumar-pudi",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Indian Institute of Technology, Madras, India",
        "AreasofInterest": "Digital Design, Cyber security and Cryptography",
        "Phone": "0877 2503264",
        "Email": "vikram@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/vikram.jpeg"
    }




]


const GuestFaculty = [


    {
        "Name": "Prof. M. V. Kartikeyan",
        "NameLink": "https://iittp.ac.in/dr-m-v-kartikeyan",
        "Position": "Professor (Currently as Director, IIITDM Kancheepuram)",
        "Degree": "Ph.D - IIT-BHU, Varanasi, India.",
        "AreasofInterest": "High-power Millimeter wave Terahertz Engineering, Sources and Allied Components; RF Circuits (RF-CAS), Antennas and Systems",
        "Phone": "0877 250 3033",
        "Email": "kartik@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/profkarthik.jpg"
    },
    {
        "Name": "Lt Dr. Gen Anil Kapoor",
        "NameLink": "#",
        "Position": "Professor of Practice, IIT Tirupati",
        "Degree": "Ph.D - Management from Punjabi University, Patiala",
        "AreasofInterest": "Design Thinking, Industrial Engineering & Automation",
        "Phone": "044-2257 XXXX",
        "Email": "anilkapoor2012@yahoo.co.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Lt Gen Anil Kapoor.jpg"
    }


]

function Main() {

    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="ELECTRICAL ENGINEERING" />
            <section className="team-area fix p-relative pt-120 pb-80">
                 
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 p-relative">
                            <div className="section-title center-align mb-50 text-center wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
                                <h5>
                                    <i className="fal fa-graduation-cap" /> People
                                </h5>
                                <h3>ELECTRICAL ENGINEERING</h3>
                            </div>
                        </div>
                    </div>

                    <Row>
                        <Col md={3} className='c-left custom-padding-color mb-4'>
                            <DeptLeft activeIndex={5} />
                        </Col>
                        <Col md={9} className='c-right'>
                            {/*--------------------------- Head of the dept */}

                            <div className="row justify-content-center">
                                <h3 className='c-headline mt-5 mb-5'>Head of the Department</h3>
                                {HD.map((HD, index) => (
                                    <div key={index} className="col-xl-5 col-md-6">
                                        {/* 
                                {index === 0 || HD.Category !== HD[index - 1].Category ? (
                                    <div>
                                        <h5 className="font-weight-bold text-teal">{HD.Category}</h5>
                                        <hr/> <br/>
                                    </div>
                                ) : null} */}

                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to={HD.NameLink}>
                                                        <img src={HD.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4 className='c-link'>
                                                    <Link to={HD.NameLink}>{HD.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                    <p>  <i className='fal fa-graduation-cap me-2' /> {HD.Position}</p>
                                                    <p className="text-dark">{HD.Degree}</p>
                                                    <p className="text-dark"> <span className='fw-bold text-dark'> Areas of Interest: </span> {HD.AreasofInterest}</p>

                                                    {(HD.Phone !== undefined && HD.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{HD.Phone}</p>
                                                    )}
                                                    <p className="text-dark"><i className="fal fa-envelope  me-1"></i>  {HD.Email}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            {/*--------------------------- Faculty*/}
                            <div className="row">
                                <h3 className='c-headline mt-5 mb-5'>Faculty</h3>
                                {Faculty.map((Faculty, index) => (
                                    <div key={index} className="col-xl-4 col-md-6">
                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to={Faculty.NameLink}>
                                                        <img src={Faculty.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4 className='c-link'>
                                                    <Link to={Faculty.NameLink}>{Faculty.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                <p > <i className="fal fa-graduation-cap me-2" /> {Faculty.Position}</p>
                                                    <p className="text-dark">{Faculty.Degree}</p>
                                                    <p className="text-dark"> <span className='fw-bold text-dark'> Areas of Interest: </span> {Faculty.AreasofInterest}</p>

                                                    {(Faculty.Phone !== undefined && Faculty.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{Faculty.Phone}</p>
                                                    )}
                                                    <p className="text-dark"><i className="fal fa-envelope  me-1"></i>  {Faculty.Email}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>





                            {/*--------------------------- Guest Faculty*/}
                            <div className="row">
                                <h3 className='c-headline mt-5 mb-5'>Guest Faculty</h3>
                                {GuestFaculty.map((GuestFaculty, index) => (
                                    <div key={index} className="col-xl-4 col-md-6">
                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to={GuestFaculty.NameLink}>
                                                        <img src={GuestFaculty.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4 className='c-link'>
                                                    <Link to={GuestFaculty.NameLink}>{GuestFaculty.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                   <p className="text-dark fw-bold">  <i className='fw-bold text-dark fal fa-graduation-cap me-2' /> {GuestFaculty.Position}</p>
                                                    <p className="text-dark">{GuestFaculty.Degree}</p>
                                                    <p className="text-dark"> <span className='fw-bold text-dark'> Areas of Interest: </span> {GuestFaculty.AreasofInterest}</p>

                                                    {(GuestFaculty.Phone !== undefined && GuestFaculty.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{GuestFaculty.Phone}</p>
                                                    )}
                                                    <p className="text-dark"><i className="fal fa-envelope  me-1"></i>  {GuestFaculty.Email}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </Col>
                    </Row>

                </div>
            </section>
        </>
    )
}

// // Function to parse HTML content and extract text
// function parseHTML(htmlString) {
//     const tempElement = document.createElement('div');
//     tempElement.innerHTML = htmlString;
//     return tempElement.textContent || tempElement.innerHTML || '';
// }


export default Main